import { reaction } from "mobx";
import EscaninhoService from "../services/EscaninhoService";
import ProcessoExpandidoService from "../services/ProcessoExpandidoService";
import ProcessoService from "../services/ProcessoService";
import ProcessoExpandidoStore from "../store/ProcessoExpandidoStore";
import ProcessoStore from "../store/ProcessoStore";

class ReactionsProcessoExpandido {
    iniciarReaction = () => {
        reaction(() => ProcessoExpandidoStore.idProcessoPainelExpandido,
            async (idEscaninho) => this.reactionTrocaIdProcessoExpandido(idEscaninho)

        );
    }

    reactionTrocaIdProcessoExpandido = async (idEscaninho) => {
        if (idEscaninho) {
            let proc = ProcessoStore._processos.find((processo) => {
                return processo.idProcessoEscaninho === idEscaninho;
            });
            if(!proc){
                proc = ProcessoStore._processosForaDoGE.find((processo) => {
                    return processo.idProcessoEscaninho === idEscaninho;
                });
            }
            await ProcessoService.atualizarDadosDoProcesso(proc.identificadorProcesso);
            await EscaninhoService.atualizarProcesso(proc.identificadorProcesso, true);
            switch (ProcessoExpandidoStore.abaSelecionada) {
                case 0:
                    ProcessoExpandidoService.consultarDadosProcesso(proc.identificadorProcesso);
                    break;
                case 1:
                    ProcessoExpandidoService.consultarEtiquetas(proc.identificadorProcesso);
                    break;
                case 2:
                    ProcessoExpandidoService.consultarMinutas(proc.identificadorProcesso);
                    ProcessoExpandidoService.consultarMinutasArquivadas(proc.identificadorProcesso);
                    ProcessoExpandidoService.consultarMinutasAssinadas(proc.identificadorProcesso);
                    break;
                case 3:
                    ProcessoExpandidoService.consultarPecas(proc.identificadorProcesso);
                    break;
            }
        }
    }

}

export default new ReactionsProcessoExpandido();